export default __webpack_public_path__ + "static/media/Login_GSB.288683ed.jpg";